<template>
  <div class="wrapper">
    <aside class="d-none d-lg-block">
      <Sidebar />
    </aside>
    <main class="p-3">
      <div class="d-flex justify-content-stretch">
        <SidebarToggle @toggle="toggleSidebar" />
        <Navbar />
      </div>
      <SidebarMobile v-if="sidebar" />
      <div class="mt-3">
        <slot />
      </div>
    </main>
  </div>
</template>

<script>
import Navbar from '@/components/DashboardNavbar'
import Sidebar from '@/components/Sidebar'
import SidebarToggle from '@/components/SidebarToggle'
import SidebarMobile from '@/components/SidebarMobile'

export default {
  components: {
    Navbar,
    Sidebar,
    SidebarToggle,
    SidebarMobile
  },

  data: () => ({
    sidebar: false
  }),

  methods: {
    toggleSidebar () {
      this.sidebar = !this.sidebar
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #f5efff;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  position: fixed;
  right: 0;
  top: 0;

  @media screen and (min-width: 992px) {
    padding-left: 294px;
  }
}

aside {
  bottom: 0;
  left: 0;
  padding: 16px;
  position: fixed;
  top: 0;
  width: 312px;
}
</style>
